<style src="vue-select/dist/vue-select.css"></style>
<style>
.table-hover {
    width: 100%;
    table-layout: fixed;
}

.table-sm {
    font-size: 14px;
}
</style>

<template>
    <section class="content">
        <div class="row">
            <div class="col-sm-12">
                <div style="font-size: 20px;font-weight: 600;">Total : {{ total }}</div>
            </div>
            <div class="col-sm-12">
                <v-data-table :headers="headers" :items="users" :loading="loading"
                    :items-per-page="pagination.itemsPerPage" :page.sync="pagination.page"
                    :server-items-length="totalItems" :footer-props="{ itemsPerPageOptions: [50, 100, 200] }"
                    @update:page="fetchUsers" @update:items-per-page="changeItemsPerPage">
                    <template #item.no="{ item, index }">
                        {{ (pagination.page - 1) * pagination.itemsPerPage + index + 1 }}
                    </template>
                   
                    
                   
                    <template #item.jumlah="{ item }">
                        <div class="text-right">
                            {{ formatRupiah(item.jumlah) }}
                        </div>
                    </template>
                </v-data-table>
            </div>
        </div>
    </section>
</template>

<script>

import { formatRupiah } from '../../helpers/format'
export default {
    props: {
        total: {
            type: String,
            required: true
        },
        id:{
            type: Number,
            required: true  
        },
        periode:{
            type: String,
            required: true
        },
        kantor_id:{
            type: Number,
            required: true
        },
        cabang_id:{
            type: Number,
            required: true
        }
    },
    watch: {
        data: {
            handler() {
                this.fetchUsers()
            },
            immediate: true, // langsung panggil saat mounted
            deep: true
        }
    },
    data() {
        return {
            user: this.$gate.user,
            users: [],
            totalItems: 0,
            loading: false,
            pagination: {
                page: 1,
                itemsPerPage: 50
            },
            headers: [
                { text: 'No', value: 'no', sortable: false, width: '30px', align: 'center' },
                { text: 'Keterangan', value: 'keterangan', sortable: true, width: '70%' },
                { text: 'Tgl.Transaksi', value: 'created_at', sortable: false, class: 'text-left', width: '60px' },
                { text: 'Nominal', value: 'jumlah', sortable: false, class: 'text-right', width: '60px' }
            ]
        }
    },
    // mounted() {
    //     this.fetchUsers()
    // },
    methods: {
        formatRupiah,
        async fetchUsers() {
            this.loading = true
            try {
                const res = await axios.get('api/laporan/laba_rugi_detail', {
                    params: {
                        page: this.pagination.page,
                        per_page: this.pagination.itemsPerPage,
                        id: this.id,
                        periode: this.periode || null,
                        kantor_id: this.kantor_id || null,
                        cabang_id: this.cabang_id || null
                    }
                })

                this.users = res.data.data
                this.totalItems = res.data.total
            } catch (e) {
                console.error(e)
            } finally {
                this.loading = false
            }
        },
        changeItemsPerPage(perPage) {
            this.pagination.itemsPerPage = perPage
            this.pagination.page = 1
            this.fetchUsers()
        }
    }
}
</script>